// @ts-check
import { h } from "./dom.js";

/** @typedef {"neutral" | "accent" | "working" | "waiting" | "idle" | "failed" | "info"} Tone */

/** Small label for a state or category (DS-07). Never shows a raw enum. @param {string} text @param {Tone} [tone] */
export function badge(text, tone = "neutral") {
  return h("span", { class: "ui-badge", dataset: { tone }, text });
}

/** Status dot with an accessible name. @param {"working" | "waiting" | "idle" | "failed" | "paused"} status @param {string} [label] */
export function statusDot(status, label) {
  return h("span", {
    class: "ui-status-dot",
    dataset: { status },
    role: label ? "img" : undefined,
    aria: { label, hidden: label ? undefined : "true" },
  });
}

/** Count pill for navigation and headings; hidden at zero. @param {number} value @param {{ tone?: "neutral" | "attention", label?: string }} [options] */
export function count(value, { tone = "neutral", label } = {}) {
  const element = h("span", {
    class: "ui-count",
    dataset: { tone },
    aria: { label },
    text: value > 99 ? "99+" : String(value),
  });
  element.hidden = !value;
  return element;
}

/** Update a count created by `count()`. @param {HTMLElement} element @param {number} value */
export function setCount(element, value) {
  element.textContent = value > 99 ? "99+" : String(value);
  element.hidden = !value;
}
